import React from 'react';
import { Home, CreditCard, Plane, User } from 'lucide-react';
interface BottomNavProps {
  activeTab: 'home' | 'card' | 'travel' | 'profile';
  onTabChange: (tab: 'home' | 'card' | 'travel' | 'profile') => void;
}
export function BottomNav({
  activeTab,
  onTabChange
}: BottomNavProps) {
  const tabs = [{
    id: 'home',
    label: 'Accueil',
    icon: Home
  }, {
    id: 'card',
    label: 'Carte',
    icon: CreditCard
  }, {
    id: 'travel',
    label: 'Voyage',
    icon: Plane
  }, {
    id: 'profile',
    label: 'Profil',
    icon: User
  }] as const;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 pb-safe pt-2 px-6 z-50 max-w-md mx-auto" data-id="element-15">
      <div className="flex justify-between items-center h-16 pb-2" data-id="element-16">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`flex flex-col items-center justify-center w-16 space-y-1 transition-colors duration-200 ${isActive ? 'text-[#D4A017]' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-17">
              <Icon size={24} strokeWidth={isActive ? 2.5 : 2} className={`transition-transform duration-200 ${isActive ? 'scale-110' : ''}`} data-id="element-18" />
              <span className="text-[10px] font-medium" data-id="element-19">{tab.label}</span>
            </button>;
      })}
      </div>
    </div>;
}